import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2a9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138A10.1 10.1 0 0 1 21.213 8.1 9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.787 3.9 10.1 10.1 0 0 1-2.138 3.175 10.1 10.1 0 0 1-3.175 2.138A9.7 9.7 0 0 1 12 22a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138A10.1 10.1 0 0 1 2.787 15.9 9.7 9.7 0 0 1 2 12a9.7 9.7 0 0 1 .787-3.9 10.1 10.1 0 0 1 2.138-3.175A10.1 10.1 0 0 1 8.1 2.787 9.7 9.7 0 0 1 12 2m0 2Q8.675 4 6.338 6.338 4 8.675 4 12t2.338 5.662T12 20t5.662-2.338Q20 15.325 20 12t-2.338-5.662Q15.325 4 12 4m1 3v4.6l3.7 3.7-1.4 1.4-4.3-4.3V7z" })
});
export default SvgClock;
